import React from "react";
import { FormCalculationSettings } from "../../components/FormCalculationSettings";
import { EditLayout } from "../../../TaxCorrections/components/EditLayout";
import { useGoBackOrToParent } from "../../../../utils/goToParentRoute";

export const RouteEditCalculationSettings: React.FC = () => {
  const goBack = useGoBackOrToParent();
  return (
    <EditLayout title="Calculation settings" onBack={goBack}>
      <FormCalculationSettings onNext={goBack} onBack={goBack} isEdit={true} />
    </EditLayout>
  );
};
